import { HttpErrorResponse } from '@angular/common/http';

import { pipeState } from '../utils';
import { SingleEntityAdapter, SingleEntityState } from './types';

export const getSingleEntityActions = <T>(adapter: SingleEntityAdapter<T>) => ({
  fetch: (state: SingleEntityState<T>): SingleEntityState<T> => adapter.markAsPending(state),
  fetchSuccess: (state: SingleEntityState<T>, data: T): SingleEntityState<T> =>
    pipeState(
      state,
      next => adapter.save(next, data),
      next => adapter.markAsLoaded(next),
    ),
  fetchFailed: (state: SingleEntityState<T>, error: HttpErrorResponse): SingleEntityState<T> =>
    adapter.setError(state, error),

  update: (state: SingleEntityState<T>, data: Partial<T>): SingleEntityState<T> =>
    adapter.markAsPending(state),
  updateSuccess: (state: SingleEntityState<T>, data: T): SingleEntityState<T> =>
    pipeState(
      state,
      next => adapter.save(next, data),
      next => adapter.markAsLoaded(next),
    ),
  updateFailed: (state: SingleEntityState<T>, error: HttpErrorResponse): SingleEntityState<T> =>
    adapter.setError(state, error),
});
